import './init.client.ts';
import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={__ENV__.AUTH0_DOMAIN}
      clientId={__ENV__.AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: __ENV__.AUTH0_AUDIENCE,
        redirect_uri: new URL('/', window.location.origin).toString(),
      }}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>,
);
